import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AslibModalComponent } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { BaseComponentService } from '../../services/base-component.service';
import { GrupoComponent } from './grupo.component';


@Component({
  selector: 'gpa-modal-grupo',
  templateUrl: './modal-grupo.component.html',
  providers: [BaseComponentService]
})

export class ModalGrupoComponent extends BaseComponentService implements OnInit {

  @Input() modoEdicao: boolean;

  projetos: any[];
  projeto: any;
  grupos: any[];
  grupo: any;

  ngOnInit() {
    this.projetos = [];
    this.projeto = '';
    this.grupos = [];
    this.grupo = '';
    this.preencheCombo('/api/InformacaoProjeto/ObterProjetosGeracaoAutomatico/1', 'projetos', 'siad');
    this.preencheComboUmParametro('/grupo', 'grupos', 'GPA', 'ascas');
  }

  salvarOnClick() {

    const dto = {
      codProjetoIntegradoPagamentoAutomatico: this.projeto,
      codGrupo: this.grupo,
    };

    this._service.routePrefix = 'api/ControleAcessoPagamentoAutomatico/';
    this.aslibLoadingService.start();

    this.subSave = this._service.add(dto, 'gpa').subscribe(data => {
        GrupoComponent.updateList.next(data);
        this.exibirSucesso('Projeto salvo com sucesso.');
      },
      erro => {
        this.exibirErro(erro);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );

  }

  cancelarOnClick() {
    GrupoComponent.updateList.next('');
  }

  carregaGrupo (param: any) {
    this.preencheComboUmParametro('/grupo', 'grupos', param, 'ascas');
  }

}



// WEBPACK FOOTER //
// ./src/app/controle-dados/grupo/modal-grupo.component.ts